import React from 'react'

const Success = () => {
  return (
    <div className="shared-messages-success">
      Fast geschafft! Bitte gehen Sie jetzt nur noch in Ihr E-Mail-Postfach, öffnen Sie die E-Mail von uns und bestätigen Sie Ihre Anmeldung.
    </div>
  );
}

export default Success
